'use strict';
angular.module('smartorg.r6.views.azure-login-fail', ['ngRoute']).config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/azure-login-fail', {
            template: require('./azure-failed.controller.html'),
            controller: 'AzureLoginFailCtrl'
        });
    }]).controller('AzureLoginFailCtrl', ['$scope', '$timeout', 'config', function ($scope, $timeout, config) {
        var smartorgApi = config.smartorg;
        $scope.loading = true;
        smartorgApi.getServerConfig().then(function (response) {
            var clientAdminEmail = response.clientAdminEmail;
            $scope.clientAdminEmail = clientAdminEmail;
            $scope.loading = false;
            $timeout();
        })["catch"](function (err) {
            console.error(err);
            alert('Error! ' + err.message);
            $scope.loading = false;
        });
    }]);
module.exports = 'smartorg.r6.views.azure-login-fail';
//# sourceMappingURL=azure-failed.controller.js.map


// WEBPACK FOOTER //
// ./app/views/azure-login-fail/azure-failed.controller.js